module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('doc-section', {
    attrs: {
      "id": "aside",
      "name": "Aside"
    }
  }, [_vm._c('div', {
    staticClass: "bs-example"
  }, [_vm._c('button', {
    staticClass: "btn btn-danger btn-lg",
    on: {
      "click": function($event) {
        _vm.showLeft = true
      }
    }
  }, [_vm._v("Show Aside on left")]), _vm._v(" "), _vm._c('button', {
    staticClass: "btn btn-success btn-lg",
    on: {
      "click": function($event) {
        _vm.showRight = true
      }
    }
  }, [_vm._v("Show Aside on right")]), _vm._v(" "), _vm._c('sidebar', {
    attrs: {
      "show": _vm.showLeft,
      "placement": "left",
      "header": "Title",
      "width": 350
    },
    on: {
      "close": function($event) {
        _vm.showLeft = false
      }
    }
  }, [_vm._c('h4', [_vm._v("Text in aside")]), _vm._v(" "), _vm._c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n      tempor incididunt ut labore et dolore magna aliqua.")]), _vm._v(" "), _vm._c('p', [_vm._v(" Ut enim ad minim veniam,\n      quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n      consequat.")]), _vm._v(" "), _vm._c('doc-code', {
    attrs: {
      "language": "javascript"
    }
  }, [_vm._v("\n        if (talk === cheap){\n          code.style.display = 'block'\n        }\n      ")]), _vm._v(" "), _vm._c('div', {
    staticClass: "aside-footer"
  }, [_vm._c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showLeft = false
      }
    }
  }, [_vm._v("Close")])])], 1), _vm._v(" "), _vm._c('sidebar', {
    attrs: {
      "show": _vm.showRight,
      "placement": "right",
      "header": "Title",
      "width": 350
    },
    on: {
      "close": function($event) {
        _vm.showRight = false
      }
    }
  }, [_vm._c('h4', [_vm._v("Text in aside")]), _vm._v(" "), _vm._c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n      tempor incididunt ut labore et dolore magna aliqua.")]), _vm._v(" "), _vm._c('p', [_vm._v(" Ut enim ad minim veniam,\n      quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n      consequat.")]), _vm._v(" "), _vm._c('doc-code', {
    attrs: {
      "language": "javascript"
    }
  }, [_vm._v("\n        if (talk === cheap){\n          code.style.display = 'block'\n        }\n      ")]), _vm._v(" "), _vm._c('div', {
    staticClass: "aside-footer"
  }, [_vm._c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showRight = false
      }
    }
  }, [_vm._v("Close")])])], 1)], 1), _vm._v(" "), _vm._c('doc-code', {
    attrs: {
      "language": "markup"
    }
  }, [_vm._v("\n    <sidebar :show=\"showRight\" placement=\"right\" header=\"Title\" width=\"350\">\n      ...\n    </sidebar>\n    <sidebar :show=\"showLeft\" placement=\"left\" header=\"Title\" width=\"350\">\n      ...\n    </sidebar>\n  ")]), _vm._v(" "), _vm._c('doc-table', [_vm._c('div', [_vm._c('p', [_vm._v("value")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("Boolean")])]), _vm._v(" "), _vm._c('p'), _vm._v(" "), _vm._c('p', [_vm._v("Whether show the component.")])]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("placement")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("String")]), _vm._v(", one of "), _vm._c('code', [_vm._v("left")]), _vm._v(", "), _vm._c('code', [_vm._v("right")])]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("right")])]), _vm._v(" "), _vm._c('p', [_vm._v("how to position the component.")])]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("header")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("String")])]), _vm._v(" "), _vm._c('p'), _vm._v(" "), _vm._c('p', [_vm._v("Header text of the aside component.")])]), _vm._v(" "), _vm._c('div', [_vm._c('p', [_vm._v("width")]), _vm._v(" "), _vm._c('p', [_vm._c('code', [_vm._v("Number")])]), _vm._v(" "), _vm._c('p'), _vm._v(" "), _vm._c('p')])])], 1)
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1babdcc9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1babdcc9!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/example/asideDocs.vue
// module id = 138
// module chunks = 0